import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import EditCustomerForm from './components/Form';
import Success from './components/Success';

export function AdminCustomersEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);

  function handleSuccess(value: boolean) {
    setIsSuccess(value);
  }

  return (
    <div className="min-h-screen">
      {isSuccess && <Success />}
      {!isSuccess && (
        <EditCustomerForm
          customerId={Number(id)}
          onSuccess={handleSuccess}
          onCancel={() => navigate(-1)}
        />
      )}
    </div>
  );
}
